import { Pipe, PipeTransform } from '@angular/core';
import { WhitelabelConfiguration } from '../models/whitelabel-config';

@Pipe({
  standalone: false,
  name: 'totalAllCount'
})
export class TotalAllCountPipe implements PipeTransform {
  transform(configurations: WhitelabelConfiguration[] | undefined): number {
    if (!configurations) return 0; 
    return configurations.length;
  }
}

@Pipe({
  standalone: false,
  name: 'totalPublishedCount'
})
export class TotalPublishedCountPipe implements PipeTransform {
  transform(configurations: WhitelabelConfiguration[] | undefined): number {
    if (!configurations) return 0; 
    const publishedConfigurations = configurations.filter(config =>
      config.ios?.status === 1 || config.android?.status === 1
    );

    return publishedConfigurations.length;
  }
}

@Pipe({
  standalone: false,
  name: 'totalUnpublishedCount'
})
export class TotalUnpublishedCountPipe implements PipeTransform {
  transform(configurations: WhitelabelConfiguration[] | undefined): number {
    if (!configurations) return 0; 

    const apps = configurations.filter(a => a.ios?.status !== 1 && a.android?.status !== 1);

    return apps.length;
  }
}

@Pipe({
  standalone: false,
  name: 'totalIosPublishedCount'
})
export class TotalIosPublishedCountPipe implements PipeTransform {
  transform(configurations: WhitelabelConfiguration[] | undefined): number {
    if (!configurations) return 0;

    const publishedIosConfigurations = configurations.filter(config =>
      config.ios?.status === 1
    );

    return publishedIosConfigurations.length;
  }
}

@Pipe({
  standalone: false,
  name: 'totalAndroidPublishedCount'
})
export class TotalAndroidPublishedCountPipe implements PipeTransform {
  transform(configurations: WhitelabelConfiguration[] | undefined): number {
    if (!configurations) return 0;

    const publishedAndroidConfigurations = configurations.filter(config =>
      config.android?.status === 1
    );

    return publishedAndroidConfigurations.length;
  }
}

export const whitelabelPipes = [
  TotalAllCountPipe,
  TotalPublishedCountPipe,
  TotalUnpublishedCountPipe,
  TotalIosPublishedCountPipe,
  TotalAndroidPublishedCountPipe
];
